import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { Routes, Route } from 'react-router-dom';
import HeadBlock from '$/components/global/heading';
import HeadTab from '$/components/global/headingTab';
import { getCloPermissioningEnabled } from '$/store/release-feature-flags/selectors';
import CloDealList from '$/pages/admin/clo/cloDealList';
import CloDealMissingMappingList from '$/pages/admin/clo/cloDealMissingMappingList';
import CloDealManageMappingList from '$/pages/admin/clo/cloDealManageMappingList';
import { getIsCurrentUserSuperAdminState } from '$/store/profile/selectors';

interface ICloDealRootProps {
  isCloPermissioningEnabled: boolean;
  isSuperAdmin: boolean;
}

const CloDealListRoot: React.FC<ICloDealRootProps> = props => {
  const { isCloPermissioningEnabled, isSuperAdmin } = props;

  const baseUrl = `/admin/clo/manage`;

  const publishProps = {
    enabled: false,
    publishEnabled: false,
    seeAllLink: '/admin/clo/manage',
  };

  return (
    <React.Fragment>
      <HeadBlock title="" publishButton={publishProps}>
        <HeadTab title="Manage CLOs" link={baseUrl} exact={true} />
        {isCloPermissioningEnabled && isSuperAdmin && (
          <HeadTab title="Missing mappings" link={`${baseUrl}/missing-mappings`} exact={true} />
        )}
        {isCloPermissioningEnabled && isSuperAdmin && (
          <HeadTab title="Manage mappings" link={`${baseUrl}/manage-mappings`} exact={true} />
        )}
      </HeadBlock>
      <Routes>
        <Route path={'/*'} element={<CloDealList />} />
        {isCloPermissioningEnabled && isSuperAdmin && (
          <Route path={'/missing-mappings'} element={<CloDealMissingMappingList />} />
        )}
        {isCloPermissioningEnabled && isSuperAdmin && (
          <Route path={'/manage-mappings'} element={<CloDealManageMappingList />} />
        )}
      </Routes>
    </React.Fragment>
  );
};

const mapStateToProps = (state: AppState) => {
  const { isSuperAdmin } = getIsCurrentUserSuperAdminState(state);
  const { isCloPermissioningEnabled } = getCloPermissioningEnabled(state);

  return {
    isLoading: state.loginState.isLoading,
    isCloPermissioningEnabled,
    isSuperAdmin,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CloDealListRoot);
